/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type VariableSlug = (typeof VariableSlug)[keyof typeof VariableSlug];

export const VariableSlug = {
  users: 'users',
  interactions: 'interactions',
  cost: 'cost',
  latency: 'latency',
  satisfaction: 'satisfaction',
  warnings: 'warnings',
  frustration: 'frustration',
  conversations: 'conversations',
  segments: 'segments',
  conversation_length: 'conversation_length',
  prompts_to_value: 'prompts_to_value',
  conversation_time: 'conversation_time',
  sentiment: 'sentiment',
  positive_messages: 'positive_messages',
  negative_messages: 'negative_messages',
  intents: 'intents',
  user_actions: 'user_actions',
  error_rate: 'error_rate',
  bounce_rate: 'bounce_rate',
  error_rate_explicit: 'error_rate_explicit',
  return_rate: 'return_rate',
  penetration: 'penetration',
  user_rating: 'user_rating',
  aifi_score: 'aifi_score',
  roi_hours_saved: 'roi_hours_saved',
  roi_hours_saved_per_user: 'roi_hours_saved_per_user',
  roi_hours_saved_per_interaction: 'roi_hours_saved_per_interaction',
  roi_successful_interactions: 'roi_successful_interactions',
  roi_success_rate: 'roi_success_rate',
  roi_value_saved: 'roi_value_saved',
  roi_value_saved_per_interaction: 'roi_value_saved_per_interaction',
  input_length: 'input_length',
  output_length: 'output_length',
  input_tokens: 'input_tokens',
  output_tokens: 'output_tokens',
  total_users: 'total_users',
} as const;
